import React from "react";
import { Download, Email, GitHub, LinkedIn } from "@mui/icons-material";
import profileImage from "../static/profile-image.jpg";
import { logResumeClick } from "../utils/eventLogger";
import "./Header.css";

const Header = () => (
  <section id="home" className="hero-section" data-scene-section="home">
    <div className="hero-content">
      <div className="destination-label" aria-label="Journey destination: planetary arrival">
        <span>01</span>
        <span>Planetary arrival</span>
      </div>
      <h1>Aviral Kumar Srivastava</h1>
      <p className="hero-role-line">Software engineer building integration systems, AI products, and research-backed tools.</p>
      <p className="hero-intro">
        I turn complex workflows into reliable software—from healthcare data exchange and cloud products to tools for software-engineering research.
      </p>
      <div className="hero-actions">
        <a className="primary-action" href="#projects">View projects</a>
        <a className="secondary-action" href="https://drive.google.com/file/d/1xJzweqCZnWiUBFgawETXBifYT2GuLokp/view?usp=drive_link" target="_blank" rel="noopener noreferrer" onClick={logResumeClick}>
          <Download fontSize="small" /> Resume
        </a>
        <a className="secondary-action" href="#contact">Get in touch</a>
      </div>
      <div className="hero-socials" aria-label="Social links">
        <a href="https://www.linkedin.com/in/aviralkumarsrivastava/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <LinkedIn fontSize="small" />
        </a>
        <a href="https://github.com/aviraw" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
          <GitHub fontSize="small" />
        </a>
        <a href="mailto:aviral23.1999@gmail.com" aria-label="Email">
          <Email fontSize="small" />
        </a>
      </div>
    </div>

    <div className="hero-visual-stage">
      <figure className="hero-portrait" aria-label="Aviral Kumar Srivastava">
        <img src={profileImage} alt="Aviral Kumar Srivastava" />
        <figcaption>
          <span>Based in California</span>
          <span>Open to engineering and research</span>
        </figcaption>
      </figure>
    </div>
    <a className="hero-scroll-cue" href="#experience" aria-label="Begin the expedition at work experience">
      <span>Begin expedition</span>
      <span aria-hidden="true">↓</span>
    </a>
  </section>
);

export default Header;
